export default {
      id: "oc-res-resource-tag-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-resource-tag",
      toString: function () {
        return this.url;
      }
    }